import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';

export default class FAQ extends Component {
  constructor(){
    super();
    this.state = {
      title: '',
      info: ''
    }
    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.handleChangeInfo = this.handleChangeInfo.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }
  componentDidMount() {
      window.scrollTo(0,0)
  }

  handleChangeTitle(event) {
    this.setState({title: event.target.value});
  }
  handleChangeInfo(event) {
    this.setState({info: event.target.value});
  }

  handleSave(event) {
    event.preventDefault()  
    var userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('faq/').push()
    const rootKey = rootRef.key 
    firebase.auth().onAuthStateChanged((user) => {
        if(user) {
            rootRef.update({
                title: this.state.title,
                info: this.state.info,
                id: rootKey,
                userId: userId,
                createDate: new Date().toLocaleDateString(),
                createTime: new Date().toLocaleTimeString(),
                email: user.email ? user.email : null,
                displayName: user.displayName ? user.displayName : null,
                photoURL: user.photoURL ? user.photoURL : null
            })
        }
      })
    window.location = ('/UserProfile/myFaqTable')
  }

  render() {
    return(
      <article className="Box">
        <MetaTags>
            <title>草學藥事 || 我想問問題</title>
            <meta id="og-title" property="og:title" content="我想問問題" />
        </MetaTags>
       <h3 style={{display: 'flex', background: '#23c7c9', justifyContent: 'center', alignItems: 'center', padding: '10px 0', color: '#fff'}}>
          我想問問題
       </h3>
       <form onSubmit={this.handleSave}>
       <small style={{color: 'rgb(255,50,50)', fontSize: 12}} >新增問題禁止有任何以下行為: 若經檢舉屬實會刪除此篇問題,嚴重累犯者取消平台權限使用資格<br/>
        1.謾罵(平台內禁止任何爭論性問題討論)<br />
        2.廣告(任何廣告行為, 需向平台申請, 不可在文章內直接發布)
       </small>
         <div style={Jeyu.MrTop}>
           <div className="group">
            <label htmlFor="title">*問題標題:</label>
            <input type="text" id="title" value={this.state.title} onChange={this.handleChangeTitle} required="true" placeholder="我常常胸悶~" />
           </div>
           <div className="group">
            <label htmlFor="info">*問題描述:</label>
            <textarea value={this.state.info} style={{padding: 7}} id="info" onChange={this.handleChangeInfo} placeholder="想問什麼就問吧"></textarea>
            <small style={{display: 'block'}} >有什麼健康方面的問題都可以在此提問喔~問題越詳細, 回答的人或醫師也能更準確的答覆喔!</small>
           </div>
          </div>
         <input type="submit" value="發問吧 GO" className="btnDefault" />
       </form>
      </article>

    )
  }
}

const Jeyu = {
  MrTop: {
    marginTop: 30
  }
}



// WEBPACK FOOTER //
// ./src/View/FAQ.js